import React from "react";
import { useTranslation } from 'react-i18next';
import { leftNav as i18nNamespace } from "../../../../i18n/namespace";

function PermissionComponent({children, hasPermssion,tooltipMessage}) {

    const { t } = useTranslation(i18nNamespace);

    if(hasPermssion) {
      return children
    }
    // TODO: Permssion message will be change in once the Main nav PR is merged
    const renderChildren = () => {
        return React.Children.map(children, (child) => {
          return React.cloneElement(child, {
            disabled: true,
            tooltip: tooltipMessage || t('user_do_not_have_access')
          });
        });
    };
    
    return renderChildren(); 
}

export default PermissionComponent
